// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"9f63d1c5","241":"b8ede9be","346":"804a9476","385":"c14cad34","401":"ebcb9878","442":"ded590b1","508":"fc89e84e","653":"fa2d4573","693":"7fb50e3f","784":"63ea0be0","866":"10b49986","920":"7adfb91b","987":"b136ca93"}[chunkId] + ".chunk.css";
};